<template>
  <div class="map-description">
    <p class="map-description__title">Диагноз</p>

    <el-select
        ref="query"
        name="diagnosis"
        style="width: 100%"
        v-model="diagnosis"
        value-key="key"
        filterable
        remote
        reserve-keyword
        placeholder="Введите значение"
        :remote-method="remoteMethod"
        class="questionnaire__select"
        @change="chooseDiagnosis"
        :loading="loading"
        maxlength=""
    >
      <el-option
          v-for="item in listItem('disease')"
          :key="item.id"
          :label="item.title"
          :value="item.id"
      >
      </el-option>

    </el-select>

    <div class="map-description__title">Формулировка для клиента</div>

    <template v-if="handleWording">
      <el-input
          type="textarea"
          v-model="wording"
          :rows="2"
          placeholder="Данный диагноз в базе отсутствует. Введите формулировку диагноза для клиента самомтоятельно..."
      ></el-input>
    </template>
    <template v-else>
      <div
          v-if="!wording"
          class="map-description__empty-comment">
        Здесь появится формулировка для клиента после выбора диагноза
      </div>
      <div v-else class="map-description__wording">{{ wording }}</div>
    </template>

    <el-button @click="enterWording()" style="margin-top: 10px;">Сохранить</el-button>

  </div>
</template>
<script>
import {mapGetters, mapActions} from "vuex"

export default {
  name: "DescriptionZones",
  props: {
    // deviations: {
    //   required: true
    // },
    point: {
      required: true
    },
    file: {
      required: true
    },
    zones: {},
    deviceId: {},
    markupDiagnosisType: {}

  },
  components: {},
  data() {
    return {
      organSystemValue: [],
      loading: false,
      answers: [],
      options: [],
      questionnaire: null,
      error: null,
      activeCompendium: 'thermoscanner',
      customDiagnosis: false,
      dirs: {},
      diagnosis: '',
      wording: '',
      handleWording: false,
    }
  },
  computed: {
    ...mapGetters("heatMap", {
      deviationsItems: "deviations",
    }),
    visitId() {
      return this.$route.params.id;
    },
    getDictionaryById() {
      if (!this.deviationsItems) return {}
      let data = this.deviationsItems.find(item => item.id === this.deviations.id)
      return data ? data : {}
    },
  },
  mounted() {

    this.init()


  },
  watch: {
    zones() {
      this.init()

    },
    point(value) {
      this.diagnosis = value.diagnosis.id
      if (value.diagnosis.id) this.customDiagnosis = false

      this.wording = this.point.description

      this.init()
    },
  },
  methods: {
    ...mapActions({
      sendZone: "heatMap/SAVE_ZONE",
      loadVisitData: "visit/LOAD_VISIT_DATA",
    }),
    init() {
      if (this.point.diagnosis) {
        this.dirs = {
          title: this.point.diagnosis.title,
          id: this.point.diagnosis.id
        }
        this.diagnosis = this.point.diagnosis.id ? this.point.diagnosis.id : this.point.diagnosis.title
        this.wording = this.point.diagnosis.description
      }
    },
    remoteMethod(query) {
      if (query === "")
        return this.options = []

      this.loading = true

      let params = {
        params: {
          type: this.markupDiagnosisType,
          search: query,
          short: !!1,
          limit: 25,
          page: 1,
        },
      }

      this.$api.questionnaire
          .compendium('markup-diagnosis', params)
          .then((response) => {
            // let options = {}
            // response.data.forEach(item => options[item.id] = item)
            response.data.push({id: 0, title: 'Добавить новый диагноз'})
            this.options = response.data
          })
          .catch(() => {
            this.options = []
          })
          .finally(() => {
            this.loading = false
          })
    },
    enterWording() {
      this.saveZone(this.diagnosis, this.wording)
    },
    chooseDiagnosis(value) {


      // Сохранение точек отклонения с найденым диагнозом
      this.customDiagnosis = true
      if (value === 0) this.creatNewDiagnosis(); else this.saveZone(value)

    },
    creatNewDiagnosis() {
      this.diagnosis = this.$refs.query.query
      this.$refs.query.handleClose()

      this.handleWording = true

      this.wording = null
      // this.enterWording()
    },
    listItem() {
      let options = this.options.filter((item) => {
        return (item.id !== this.dirs.id)
      })

      return this.options.length ? options : this.dirs.id ? [this.dirs] : []
    },
    saveZone(diagnosisId = this.diagnosis, wording) {
      this.$emit('save')

      let payload = {
        visit_id: this.visitId,
        device_id: this.deviceId,

        pointId: this.point.pointId,
        coords: this.point.files,
        // visit_diagnostic_result_id: this.file.visitDiagnosticResultId
      }

      if (typeof this.diagnosis === "number") {
        payload.diagnosis_id = diagnosisId
      } else {
        payload.diagnosis_title = diagnosisId
        if (wording) payload.diagnosis_description = wording
      }

      if (!payload.diagnosis_id && !payload.diagnosis_title) {
        this.$notify.warning({
          title: "Укажите диагноз области",
          message: "Выберите диагноз или укажите новый для данной области",
        })

        return
      }

      this.sendZone(payload).then(response => {
        this.$notify.success({
          title: "Успешно",
          message: "Выбранная область была " + (this.point.pointId ? "обновлена" : "сохранена"),
        })

        if (!this.point.pointId) this.point.pointId = response.id
        this.loadVisitData({ visitId: this.visitId })

      }, error => {
        this.$notify.error({
          title: "Ошибка сохранения области 😕",
          message: error.response.data.message,
        })

        this.loadVisitData({ visitId: this.visitId })
      })

    },
  }
}
</script>

<style scoped lang="scss">
.map-description {
  &__select {
    margin: 10px 0;
    width: 100%;
  }

  &__save {
    margin-top: 10px;
  }

  &__title:first-child {
    margin: 0;
  }

  &__title {
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;

    color: #111;
    margin: 16px 0 0 0;

  }

  &__empty-comment {
    margin-top: 4px;


    font-size: 12px;
    line-height: 13px;
    color: #8E8E93;
  }

  &__wording {
    margin-top: 4px;

    font-size: 12px;
    line-height: 13px;
    color: #111;
  }

  /deep/ .el-select {
    margin-top: 10px;
    width: 100%;
  }

  /deep/ .el-textarea {
    margin-top: 10px;
    width: 100%;
  }

}

.create-new-item {
  padding: 10px 5px;
  font-size: 14px;
  font-weight: 500;

  a {
    vertical-align: bottom;
  }
}
</style>
